import {
  formatHourShort,
  simpleDayNightBands,
} from '../../../../shared/charts/chart-utils';
import type { TimeSeriesPoint } from '../../../../shared/charts/types';
import { weatherDaySwipeIgnoreProps } from '../../helpers/day/daySwipe';

/** Figma bar-chart plot band is ~75px (Group 406 outer rects are 90px with inset). */
export const WEATHER_CHART_PLOT_HEIGHT = 75;

/** Natural cubic spline (Bézier segments) for temperature and UV area charts. */
export const WEATHER_BEZIER_AREA_CURVE = 'natural' as const;

/** Shared bar styling for wind/swell forecast charts (Figma Group 406). */
export const WEATHER_CHART_BAR_STYLE = {
  topRadius: 4,
  maxBarWidth: 16,
  defaultBarWidth: 10,
  inactiveWhiteMix: 0.6,
} as const;

export const WEATHER_CHART_CHROME_COLORS = {
  nightBand: 'rgba(0, 0, 0, 0.08)',
} as const;

/** Day/night background shading on weather forecast graphs. */
export const WEATHER_CHART_SHOW_BACKGROUND_GRADIENT = false;

/** Apply to the plot hit-target so day swipe ignores scrubbing, not x-axis labels. */
export const WEATHER_CHART_PLOT_INTERACTION_PROPS = weatherDaySwipeIgnoreProps;

export const buildWeatherChartBands = (
  domain: { start: Date; end: Date },
  timeZone: string,
) => simpleDayNightBands(domain.start, domain.end, { timeZone });

export const createWeatherChartXTickFormatter =
  (timeZone: string) =>
  (tick: Date): string =>
    formatHourShort(tick, timeZone);

export interface WeatherChartScrubProps {
  selectedTime?: Date | null;
  defaultSelectedTime?: Date;
  onSelectedTimeChange?: (time: Date, index: number) => void;
  onScrubStart?: () => void;
  onScrubEnd?: () => void;
}

export interface WeatherChartBaseProps extends WeatherChartScrubProps {
  data: TimeSeriesPoint[];
  domain: { start: Date; end: Date };
  timeZone: string;
}
